import { gql } from '@apollo/client';

const GET_CHECK_POINTS = gql`
  query GetCheckPoints($orgUnitId: Int!) {
    checkPoints(orgUnitId: $orgUnitId) {
      Id
      Name
      AppraisalOrgUnits {
        Appraisal {
          Id
          ConductAppraisalEndDate
        }
        CheckPoints {
          Id
          DataCollectionDate
          IsDraft
        }
      }
    }
  }
`;

export default GET_CHECK_POINTS;
